<app-modal
  svgIcon="key"
  [title]="'Backoffice for Sales Access'"
  [closeButton]="false">
  <ng-container body>
    <p class="body-l-bold">
      The Backoffice for sales is not adapted to be launched in this device.
      Please Use it in Desktop device
    </p>
    <p class="body-l">
      {{ 'error-server-modal.problem-persist' | translate }}
      <a (click)="closeModal()"
         class="cancel-modal-link"
         [routerLink]="['/contact']">
        {{ 'error-server-modal.contact-support-team' | translate }}</a>
      {{ 'error-server-modal.for-assistance' | translate }}
      {{ 'error-server-modal.apologize' | translate }}
    </p>
  </ng-container>
  <ng-container footer>
    <app-button
      type="primary"
      size="large"
      [text]="'error-server-modal.back-to-home-page' | translate"
      [routerLink]="['/']"
      (click)="closeModal()">
    </app-button>
  </ng-container>
</app-modal>
